import { Card, ThemeProvider } from "@mui/material";
import LoadingScreen from "components/loading/LoadingScreen";
import { ALL_OPTION } from "constant";
import moment from "moment";
import ReportCallMeDingdongFilter from "pages/cloudPbx/report-call-me-dingdong/components/ReportCallMeDingdongFilter";
import { useEffect, useState } from "react";
import { useExportGetReportCallMeDingdong } from "service/query/inbound.query";
import muiTheme from "theme/muiTheme";

const ReportCallMeDingdong = () => {
  const [filter, setFilter] = useState(null);

  const handleSubmit = (values) => {
    const fromNow = moment(values.dateRangeNow[0]).format("YYYY-MM-DD");
    const toNow = moment(values.dateRangeNow[1]).format("YYYY-MM-DD");
    const fromThen = moment(values.dateRangeThen[0]).format("YYYY-MM-DD");
    const toThen = moment(values.dateRangeThen[1]).format("YYYY-MM-DD");

    // Ban đầu ALL nên tất cả giá trị value = null
    // Check chỉ gửi điều kiện nhỏ nhất lên
    let value = null;
    let groupBy = "all";

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district === ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      groupBy = "city";
      value = values.cityCode;
    }
    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg === ALL_OPTION.value
    ) {
      groupBy = "district";
      value = values.district;
    }

    if (
      values.cityCode !== ALL_OPTION.value &&
      values.district !== ALL_OPTION.value &&
      values.subOrg !== ALL_OPTION.value
    ) {
      groupBy = "postoffice";
      value = values.subOrg;
    }

    setFilter({
      groupBy,
      value,
      fromNow,
      toNow,
      fromThen,
      toThen,
    });
  };

  // const { refetch: handleExport, isFetching: isFetchingExport } =
  //   useExportDetailInboundCall(filter, null, modalExportHistories.openModal);
  const { refetch: handleExport, isFetching: isFetchingExport } =
    useExportGetReportCallMeDingdong(
      {
        ...filter,
      },
      {
        enabled: false,
        staleTime: 0,
      }
    );
  useEffect(() => {
    if (filter) {
      handleExport();
    }
  }, [filter]);

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ mb: 2 }}>
        <ReportCallMeDingdongFilter onSubmit={handleSubmit} />
      </Card>

      <LoadingScreen loading={isFetchingExport} />
    </ThemeProvider>
  );
};

export default ReportCallMeDingdong;
